import { useMemo } from 'react';
import { useReportOutletContext } from '@data/pages/ReportLayout/ReportLayout';
import { Drilldown } from '@data/main';
import { resolveMetrics, type MetricRule } from '@data/utils/resolve-metrics';
import { MetricTableType } from '@data/hooks/api/use-metrics-table-v2-api/use-metrics-table-v2-api';
import { AssessmentReportPage } from '@data/components/report/AssessmentReportPage/AssessmentReportPage';

// ── GE Report Primary Metrics ──────────────────────────────────────────────────

const PRIMARY_METRICS: MetricRule[] = [
  { metric: 'GE_FIRST_ASSESSMENTS_COMPLETE' },
  { metric: 'GE_LAST_ASSESSMENTS_COMPLETE' },
];

// ── Component ──────────────────────────────────────────────────────────────────

export function GEPage() {
  const { drilldown, productId: edApp } = useReportOutletContext();

  const primaryMetricTypes = resolveMetrics(PRIMARY_METRICS, edApp, drilldown);

  const tableConfig = useMemo(
    () => ({
      metricType:
        drilldown === Drilldown.Class
          ? MetricTableType.IndividualClassGEAssessments
          : MetricTableType.AllClassGEAssessments,
      defaultSortColumn: drilldown === Drilldown.Class ? 'STUDENT' : 'CLASS',
      drilldownPath: `/data/${edApp}/ge-score/class`,
    }),
    [drilldown, edApp]
  );

  return (
    <AssessmentReportPage
      primaryMetricTypes={primaryMetricTypes}
      proficiencyMetricType="ALL_CLASS_GE_PROFICIENCY"
      tableConfig={tableConfig}
    />
  );
}
